import React, { useState, useRef } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Users from "./pages/Users";
import SelectedUsers from "./pages/SelectedUser";
import MainPage from "./pages/MainPage";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { InputText } from "primereact/inputtext";
import "tailwindcss/tailwind.css";
import yerlembg from "./images/yerlemicon.svg";
import yerlemlogo from "./images/yerlemlogo.svg";
import { Toast } from "primereact/toast";
import {Sidebar} from 'primereact/sidebar'
import AddUser from "./pages/AddUser";
import AdminPage from "./pages/AdminPage";
import LogPage from "./pages/LogPage";
import Message from "./pages/Message";
import Mail from "./pages/Mail";
import MessageLog from "./pages/MessageLog";
import SchoolLogPage from "./pages/SchoolLogPage";
import YerlemApps from "./pages/YerlemApps";

function App() {
  const toast = useRef(null);

  let items = [
    { text: "Ana Sayfa", icon: "pi pi-home", path: "/home" },
    { text: "Tüm Kullanıcılar", icon: "pi pi-users", path: "/allUsers" },
    { text: "AYD Admin Paneli", icon: "pi pi-id-card", path: "/adminPage" },
    { text: "Log Geçmişi", icon: "pi pi-book", path: "/logPage" },
    { text: "Okul Log Geçmişi", icon: "pi pi-book", path: "/schoolLogPage" },
    { text: "SMS Gönderme", icon: "pi pi-comments", path: "/message" },
    { text: "SMS Geçmişi", icon: "pi pi-comments", path: "/messageLog" },
    { text: "E posta Gönderme",icon: "pi pi-envelope", path: "/email" },
    { text: "Yerlem Uygulama Listesi",icon: "pi pi-microsoft", path: "/yerlemapps" },
  ];

  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [sidebarVisible, setSidebarVisible] = useState(false)
  const [loggedIn, setLoggedIn] = useState(
    sessionStorage.getItem("loggedIn") === "true" // Kontrol için sessionStorage'ı kullanıyoruz
  );
  const [enterPressed, setEnterPressed] = useState(false);

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
    setEnterPressed(false); // Reset enterPressed to false when the username changes
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setEnterPressed(false); // Reset enterPressed to false when the password changes
  };

  const showError = () => {
    toast.current.show({
      severity: "error",
      summary: "Hata",
      detail: "Kullanıcı adı veya şifre hatalı",
      life: 3000,
    });
  };

  const handleLogin = () => {
    if (!loggedIn && username === "yerlem" && password === "yerlem") {
      setLoggedIn(true);
      sessionStorage.setItem("loggedIn", "true"); // Doğru giriş durumunda sessionStorage'a kaydediyoruz
    } else if (!loggedIn) {
      showError();
      setEnterPressed(true);
    }
  };

  return (
    <div className="h-screen w-ful">
      {loggedIn ? (
        <div className="flex flex-row h-full">
          <Sidebar
            visible={sidebarVisible}
            onHide={() => setSidebarVisible(false)}
          >
              {items.map((item) => (
                <a href={item.path}>
                  <Button
                    severity="info"
                    className="w-full my-1"  
                    icon={item.icon}
                    size="small"
                    label={item.text}
                  />
                </a>
              ))}
          </Sidebar>
          <div className="flex-1 h-full ">
            <div className="h-full">
              <BrowserRouter>
                <Routes>
                  <Route
                    path="/"
                    element={<MainPage setSidebarVisible={setSidebarVisible} />}
                  />
                  <Route
                    path="/home"
                    element={<MainPage setSidebarVisible={setSidebarVisible} />}
                  />
                  <Route
                    path="/allUsers"
                    element={<Users setSidebarVisible={setSidebarVisible} />}
                  />
                  <Route
                    path="/selectedUsers"
                    element={
                      <SelectedUsers setSidebarVisible={setSidebarVisible} />
                    }
                  />
                   <Route
                    path="/addUser"
                    element={
                      <AddUser setSidebarVisible={setSidebarVisible} />
                    }
                  />
                   <Route
                    path="/adminPage"
                    element={
                      <AdminPage setSidebarVisible={setSidebarVisible} />
                    }
                  />
                   <Route
                    path="/logPage"
                    element={
                      <LogPage setSidebarVisible={setSidebarVisible} />
                    }
                  />
                   <Route
                    path="/schoolLogPage"
                    element={
                      <SchoolLogPage setSidebarVisible={setSidebarVisible} />
                    }
                  />
                   <Route
                    path="/message"
                    element={
                      <Message setSidebarVisible={setSidebarVisible} />
                    }
                  />
                   <Route
                    path="/messageLog"
                    element={
                      <MessageLog setSidebarVisible={setSidebarVisible} />
                    }
                  />
                   <Route
                    path="/email"
                    
                    element={
                      <div className="h-full w-full" >
                      <Mail setSidebarVisible={setSidebarVisible} />
                      </div>
                    }
                  />
                   <Route
                    path="/yerlemapps"
                    
                    element={
                      <div className="h-full w-full" >
                      <YerlemApps setSidebarVisible={setSidebarVisible} />
                      </div>
                    }
                  />
                </Routes>
              </BrowserRouter>
              <div className="fixed bottom-0 left-0 right-0 bg-white/50  px-8 flex justify-between items-center">
                <div>TERRA SOFTWARE INFORMATICS LLC.</div> <div>All right reserved</div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="relative bg-white min-h-screen flex justify-center items-center">
          <img src={yerlembg} alt="BG" className="absolute h-full object-cover z-0 " />
          <div className="flex flex-col justify-center items-center z-1">
            <img src={yerlemlogo} alt="logo" />
            <div className="flex w-full   flex-col py-4 rounded-2xl">
              <div className="flex w-full   flex-col mb-1">
                <label htmlFor="username">Kullanıcı Adı</label>
                <InputText
                  className="mt-1 w-80"
                  id="username"
                  value={username}
                  onChange={handleUsernameChange} // Değişiklik burada
                  aria-describedby="username-help"
                />
              </div>
              <div className="flex flex-col w-full  mb-4">
                <label htmlFor="password">Parola</label>
                <Password
                  className="mt-1"
                  value={password}
                  inputStyle={{ width: "100%" }}
                  style={{ width: "100%" }}
                  onChange={handlePasswordChange}
                  feedback={false}
                  onKeyUp={(e) => {
                    if (e.key === "Enter" && !enterPressed) {
                      e.stopPropagation();
                      handleLogin();
                    }
                  }}
                />
              </div>

              <div className="flex flex-col">
                <Button
                  severity="info"
                  className="w-full"
                  size="small"
                  label="Giriş Yap"
                  onClick={handleLogin}
                />
                <Toast ref={toast} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
